module.exports = __webpack_public_path__ + "img/IMG-20190904-WA0013.1a00bead.jpg";